import { Component, OnInit, ViewChild, Directive, Input } from '@angular/core';
import { ClienteLogin, ClienteXCiudad } from "../../login/cliente_login";
import { correctHeight, detectBody } from "../../../app.helpers";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { HandleError } from "../../../components/common/utils/handleError.component";
import { Router } from '@angular/router';
import { SessionTokenService } from "../../../components/common/utils/sessionToken.service";
import { ModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";
import { AplicacionesTransporteService } from "./aplicaciones-transporte.service";
import { AplicacionesTransporteResumen, AplicacionesConsulta, AplicacionEntityConsulta, AplicacionesMovimientos } from "../entities/aplicaciones_transporte_entity";
import { UtilService } from "../../../components/common/utils/util.service";
import { PolizaEntity } from "../entities/polizas_cliente_entity";
import { CalendarFechaNac } from "../../../components/common/utils/calendarFechaNacParametros";
import { ParametrosURL } from "../../../components/common/utils/entities/parametrosURL_entity";

const swal = require("sweetalert2");

declare var jQuery: any;
@Component({
    selector: 'aplicacionesTransporteConsulta',
    styleUrls: ["aplicaciones-transporte.style.css"],
    templateUrl: 'aplicaciones-transporte-consulta.template.html'
})

export class AplicacionesTransporteConsultaComponent extends CalendarFechaNac implements OnInit {
    usuario: ClienteLogin;
    usuarioEmpresa: ClienteXCiudad;
    public showLoader: string;
    aplicacionesConsulta: AplicacionesConsulta;
    consultaAplicacion: AplicacionEntityConsulta;
    consultaAplicaciones: AplicacionesMovimientos[];
    fechaDesde: Date;
    fechaHasta: Date;
    bandera: boolean;
    banderaNuevo: boolean;
    banderaGenerar: boolean;
    filterQuery: string;

    constructor(private router: Router, private aplicacionesTransporteService: AplicacionesTransporteService, private sesionStorageService: SessionStorageService, private handleError: HandleError,
        private sessionTokenService: SessionTokenService, public utilsService: UtilService) {
        super();
    }
    ngOnInit() {
        /*correctHeight();
        detectBody();*/
        this.showLoader = "";
        this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
        if (this.usuario == null) {
            let error = { "status": 998, "message": "Acceso denegado" };
            this.handleError.redirectUrl(error)
        } else {
            let bandera = this.sessionTokenService.useJwtHelper();
            if (!bandera) {
                this.banderaGenerar = false;
                this.banderaNuevo = false;
                this.usuarioEmpresa = new ClienteXCiudad();
                this.consultaAplicacion = new AplicacionEntityConsulta();
                this.consultaAplicaciones = new Array<AplicacionesMovimientos>();
                try {
                    this.usuarioEmpresa = jQuery.parseJSON(this.sesionStorageService.retrieve("usuarioEmpresa"));
                } catch (e) {
                    this.usuarioEmpresa = this.sesionStorageService.retrieve("usuarioEmpresa");
                }
                this.aplicacionesTransporteService.ConsultarPolizaAplicacionTransporte(this.usuarioEmpresa).subscribe(result => {
                    if (result.value) {
                        this.banderaNuevo = result.value;
                    }
                },
                    error => { this.handleError.redirectUrl(error); });
                this.sesionStorageService.observe("usuarioEmpresa").subscribe(v => {
                    try {
                        this.usuarioEmpresa = jQuery.parseJSON(v);
                        this.consultaAplicacion = new AplicacionEntityConsulta();
                        this.consultaAplicaciones = new Array<AplicacionesMovimientos>();
                    } catch (e) {
                        this.usuarioEmpresa = v;
                        this.consultaAplicacion = new AplicacionEntityConsulta();
                        this.consultaAplicaciones = new Array<AplicacionesMovimientos>();
                    }
                    this.bandera = false;
                    this.aplicacionesTransporteService.ConsultarPolizaAplicacionTransporte(this.usuarioEmpresa).subscribe(result => {
                        if (result.value) {
                            this.banderaNuevo = result.value;
                        }
                    },
                        error => { this.handleError.redirectUrl(error); });
                });
                this.bandera = false;
            }
        }
    }

    consultarAplicaciones() {
        this.showLoader = "sk-loading";
        this.consultaAplicacion.CiudadCodigo = this.usuarioEmpresa.Ciudad;
        this.consultaAplicacion.ClienteCodigo = this.usuarioEmpresa.CodigoCliente;
        this.consultaAplicacion.FechaDesde = this.dateDesde;
        this.consultaAplicacion.FechaHasta = this.dateHasta;
        this.aplicacionesTransporteService.consultarWebServiceUO(this.consultaAplicacion).subscribe(resultado => {
            this.consultaAplicaciones = JSON.parse(resultado);
            this.consultaAplicaciones.forEach(a => {
                a.Accion = 0;
            });
            this.bandera = true;
            if(this.consultaAplicaciones.length > 0){
                this.banderaGenerar = true;
            }
            this.showLoader = "";
        },
            error => {
                this.handleError.redirectUrl(error);
            });
    }

    OpcionesChangeAplicaciones(aplicacion: AplicacionesMovimientos) {
        if (aplicacion.Accion == 1) {
            swal({
                title: 'Está seguro?',
                text: "Usted no podrá revertir este cambio!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si',
                cancelButtonText: 'No'
            }).then((function() {
                this.aplicacionesTransporteService.AnularAplicacionTransporte(aplicacion).subscribe(
                    result => {
                        this.consultarAplicaciones();
                        aplicacion.Accion = 0;
                        if (result) {
                            swal(
                                'Anulado!',
                                'La Aplicación se anuló correctamente.',
                                'success'
                            );
                        } else {
                            swal(
                                'Error!',
                                'No se pudo realizar esta acción.',
                                'error'
                            );
                        }
                    },
                    error => { this.handleError.redirectUrl(error); }
                );
            }).bind(this))
        }
        if (aplicacion.Accion == 2) {
            let Data = new ParametrosURL();
            let reporte = 0;
            if (aplicacion.NumeroMovimiento != 0) {
                Data.parametros = aplicacion.Ciudad + "," + aplicacion.NumeroMovimiento + "," + aplicacion.DetalleMovimiento + "," + aplicacion.AlcanceMovimiento + "," + aplicacion.Cliente;
                reporte = 1;
            } else {
                Data.parametros = aplicacion.NumeroAplicacion + "," + aplicacion.Ciudad + "," + aplicacion.Unicod + "," + aplicacion.Poliza + "," + aplicacion.Cliente;
                reporte = 2;
            }
            this.utilsService.encriptaParametrosURL(Data).subscribe(
                result => {
                    if (reporte == 1) {
                        window.open("http://enlinea.tecniseguros.com.ec:8081/MenuUnidadOperativa/Reportes/ReporteAplicacionTransporte.aspx?parametro=" + result, "_blank"); 
                    }
                    else {
                        window.open("http://enlinea.tecniseguros.com.ec:8081/MenuUnidadOperativa/Reportes/ReporteAplicacionTransportesAnterior.aspx?parametro=" + result, "_blank");
                    }
                    aplicacion.Accion = 0;
                },
                error => { this.handleError.redirectUrl(error); }
            );
        }
    }
    nuevaAplicacion() {
        let Data = new ParametrosURL();
        let reporte = 0;
        this.aplicacionesTransporteService.ConsultarUnidadAplicacionTransporte(this.usuarioEmpresa).subscribe(
            result => {
                Data.parametros = this.usuarioEmpresa.Ciudad + "," + result + "," + this.usuarioEmpresa.CodigoCliente + ",0,0,0,1";
                this.utilsService.encriptaParametrosURL(Data).subscribe(
                    result => {
                        /*window.open("http://re0140:8082/MenuUnidadOperativa/AdmIngresoMovimiento.aspx?parametro=" + result, "_blank");*/
                        window.open("http://enlinea.tecniseguros.com.ec:8081/MenuUnidadOperativa/AdmIngresoMovimiento.aspx?parametro=" + result, "_blank");
                    },
                    error => { this.handleError.redirectUrl(error); }
                );
            }, error => { this.handleError.redirectUrl(error); });
    }

    consultarReporte() {
        let Data = new ParametrosURL();
        let reporte = 0;
        Data.parametros = this.usuarioEmpresa.Ciudad + "," + this.dateDesde + "," + this.dateHasta + "," + this.usuarioEmpresa.CodigoCliente;
        this.utilsService.encriptaParametrosURL(Data).subscribe(
            result => {
                /*window.open("http://re0140:8082/MenuUnidadOperativa/Reportes/AdmRepCtrlAplicaciones.aspx?parametro=" + result, "_blank");*/
                window.open("http://enlinea.tecniseguros.com.ec:8081/MenuUnidadOperativa/Reportes/AdmRepCtrlAplicaciones.aspx?parametro=" + result, "_blank");
            },
            error => { this.handleError.redirectUrl(error); }
        );
    }

    set dateDesde(e) {
        this.fechaDesde = new Date(e);
    }

    get dateDesde() {
        if (this.fechaDesde != undefined) {
            try {
                var a = this.fechaDesde.toISOString().substring(0, 10);
                var b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            } catch (e) {
                var a = this.fechaDesde.toString().substring(0, 10);
                var b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            }
        }
    }

    set dateHasta(e) {
        this.fechaHasta = new Date(e);
    }

    get dateHasta() {
        if (this.fechaHasta != undefined) {
            try {
                var a = this.fechaHasta.toISOString().substring(0, 10);
                var b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            } catch (e) {
                var a = this.fechaHasta.toString().substring(0, 10);
                var b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            }
        }
    }
}





// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/aplicacionesTransporte/aplicaciones-transporte-consulta.component.ts